<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="setBlockStatus">
            <b-form-group :label="$t('kkm.blocked')" label-cols-sm="3">
                <b-form-checkbox v-model="formData.isBlocked"></b-form-checkbox>
            </b-form-group>
            <b-form-group :label="$t('kkm.comment')" label-cols-sm="3">
                <b-form-input v-model="formData.blockingReason"></b-form-input>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
export default {
    name: 'SetBlockStatusForm',
    props: {
        kkmId: Number,
        blocked: Boolean
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                id: this.kkmId,
                isBlocked: this.blocked,
                blockingReason: null
            }
        }
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        setBlockStatus: function () {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.setBlockStatus,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('kkm.blockStatusSetMessage')
                }, this.displayAlert)
        },
        hideAlert: function () {
            this.showAlert = false
            this.showSuccessAlert = false
            this.alert = ''
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        }
    }
}
</script>
